import React from 'react';
import Translate from '../../components/Translate';

export var getKycReason = function getKycReason(reason) {
  var reasons = {
    AllCornersMustBeVisible: React.createElement(Translate, {
      id: 'label.reason-AllCornersMustBeVisible',
      defaultMessage: 'All corners must be visible'
    }),
    BlackWhiteCopyNotAcceptable: React.createElement(Translate, {
      id: 'label.reason-BlackWhiteCopyNotAcceptable',
      defaultMessage: 'Black white copy not acceptable'
    }),
    InformationNotVisible: React.createElement(Translate, {
      id: 'label.reason-InformationNotVisible',
      defaultMessage: 'Information not visible'
    }),
    ExpiredCard: React.createElement(Translate, { id: 'label.reason-ExpiredCard', defaultMessage: 'Expired card' }),
    ScannedDocument: React.createElement(Translate, {
      id: 'label.reason-ScannedDocument',
      defaultMessage: 'Scanned document'
    }),
    BadQuality: React.createElement(Translate, { id: 'label.reason-BadQuality', defaultMessage: 'Bad quality' }),
    Flash: React.createElement(Translate, { id: 'label.reason-Flash', defaultMessage: 'Flash' }),
    MissingIssueDate: React.createElement(Translate, {
      id: 'label.reason-MissingIssueDate',
      defaultMessage: 'Missing issue date'
    }),
    NoOfficialLogo: React.createElement(Translate, {
      id: 'label.reason-NoOfficialLogo',
      defaultMessage: 'No official logo'
    }),
    IncorrectCardNumbers: React.createElement(Translate, {
      id: 'label.reason-IncorrectCardNumbers',
      defaultMessage: 'Incorrect card numbers'
    }),
    MissingSignatureOnCardBack: React.createElement(Translate, {
      id: 'label.reason-MissingSignatureOnCardBack',
      defaultMessage: 'Missing signature on card back'
    }),
    MissingName: React.createElement(Translate, { id: 'label.reason-MissingName', defaultMessage: 'Missing name' }),
    AccountNumberNotVisible: React.createElement(Translate, {
      id: 'label.reason-AccountNumberNotVisible',
      defaultMessage: 'Account number not visible'
    }),
    OldDocument: React.createElement(Translate, { id: 'label.reason-OldDocument', defaultMessage: 'Old document' }),
    MissingAdress: React.createElement(Translate, {
      id: 'label.reason-MissingAdress',
      defaultMessage: 'Missing adress'
    }),
    WrongDocument: React.createElement(Translate, {
      id: 'label.reason-WrongDocument',
      defaultMessage: 'Wrong document'
    }),
    NameOrExipreDateCovered: React.createElement(Translate, {
      id: 'label.reason-NameOrExipreDateCovered',
      defaultMessage: 'Name or exipre date covered'
    }),
    BackMissing: React.createElement(Translate, { id: 'label.reason-BackMissing', defaultMessage: 'Back missing' }),
    FrontMissing: React.createElement(Translate, {
      id: 'label.reason-FrontMissing',
      defaultMessage: 'Front missing'
    }),
    OtherCards: React.createElement(Translate, { id: 'label.reason-OtherCards', defaultMessage: 'Other cards' }),
    ScreenshotOrStampedDoc: React.createElement(Translate, {
      id: 'label.reason-ScreenshotOrStampedDoc',
      defaultMessage: 'Screenshot or stamped doc'
    }),
    WrongCardNumber: React.createElement(Translate, {
      id: 'label.reason-WrongCardNumber',
      defaultMessage: 'Wrong card number'
    }),
    OtherAccounts: React.createElement(Translate, {
      id: 'label.reason-OtherAccounts',
      defaultMessage: 'Other accounts'
    }),
    NetellerNewMemberSite: React.createElement(Translate, {
      id: 'label.reason-NetellerNewMemberSite',
      defaultMessage: 'Neteller new member site'
    }),
    SkrillNetellerScreenshot: React.createElement(Translate, {
      id: 'label.reason-SkrillNetellerScreenshot',
      defaultMessage: 'Skrill neteller screenshot'
    }),
    NetellerDropDown: React.createElement(Translate, {
      id: 'label.reason-NetellerDropDown',
      defaultMessage: 'Neteller drop down'
    })
  };

  return reasons[reason] || reason;
};